export const identity = <T>(arg: T) => arg;
